export const LISTING_LIB_INTERACTION = 'listingLibInteraction';